export var DeliveryTypes;
(function (DeliveryTypes) {
    DeliveryTypes[DeliveryTypes["Courier"] = 3] = "Courier";
    DeliveryTypes[DeliveryTypes["SameDay"] = 4] = "SameDay";
    DeliveryTypes[DeliveryTypes["Post"] = 1] = "Post";
    DeliveryTypes[DeliveryTypes["PickPoint"] = 14] = "PickPoint";
    DeliveryTypes[DeliveryTypes["CDEK"] = 15] = "CDEK";
})(DeliveryTypes || (DeliveryTypes = {}));
